import { render } from "./InquiryTypeForm.vue?vue&type=template&id=363d45d5&scoped=true"
import script from "./InquiryTypeForm.vue?vue&type=script&lang=js"
export * from "./InquiryTypeForm.vue?vue&type=script&lang=js"

import "./InquiryTypeForm.vue?vue&type=style&index=0&id=363d45d5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363d45d5"]])

export default __exports__